const system = window.env.system

export default {
  state: system
}